.sample-section{margin-bottom:20px}
/*# sourceMappingURL=questionnaire-sample.component-OOL7JRBW.css.map */
